'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCaretPosition = setCaretPosition;
exports.deleteTimes = deleteTimes;
/**
 * @file: content-editable-utils
 * @author: Cuttle Cong
 * @date: 2017/11/5
 * @description: 
 */

function setCaretPosition(elem, caretPos) {
    if (elem != null) {
        if (elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        } else {
            if (elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            } else elem.focus();
        }
    }
}

function deleteTimes(times) {
    for (var i = 0; i < times; i++) {
        document.execCommand('delete', false);
    }
}


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/utils/contentEditableUtils.js